import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import forceRankGroupAxios from '../../axios/forceRankGroup'
import baseAxios from '../../axios/base'

export const fetchForceRankGroup = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchForceRankGroupStart())
    forceRankGroupAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchForceRankGroupSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchForceRankGroupFailed(error))
      })
  }
}

export const fetchForceRankGroupStart = () => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_START
  }
}

export const fetchForceRankGroupSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_SUCCESS,
    pagination,
    records
  }
}

export const fetchForceRankGroupFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_FAILED,
    errorMessage
  }
}

export const fetchForceRankGroupById = recordId => {
  return dispatch => {
    dispatch(fetchForceRankGroupStart())
    forceRankGroupAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchForceRankGroupByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchForceRankGroupFailed(error))
      })
  }
}

export const fetchForceRankGroupByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedForceRankGroupRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_FORCE_RANK_GROUP_RECORD
  }
}

export const createForceRankGroup = (recordData, page) => {
  return dispatch => {
    dispatch(createForceRankGroupStart())

    forceRankGroupAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'ForceRankGroup Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createForceRankGroupSuccess())
          dispatch(fetchForceRankGroup(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid ForceRankGroup field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createForceRankGroupFailed())
      })
  }
}

export const createForceRankGroupStart = () => {
  return {
    type: actionTypes.CREATE_FORCE_RANK_GROUP_START
  }
}

export const createForceRankGroupSuccess = () => {
  return {
    type: actionTypes.CREATE_FORCE_RANK_GROUP_SUCCESS
  }
}

export const createForceRankGroupFailed = () => {
  return {
    type: actionTypes.CREATE_FORCE_RANK_GROUP_FAILED
  }
}

export const updateForceRankGroup = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateForceRankGroupStart())
    forceRankGroupAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'ForceRankGroup Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateForceRankGroupSuccess())
        dispatch(fetchForceRankGroup(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid ForceRankGroup field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateForceRankGroupFailed())
      })
  }
}

export const updateForceRankGroupStart = () => {
  return {
    type: actionTypes.UPDATE_FORCE_RANK_GROUP_START
  }
}

export const updateForceRankGroupSuccess = () => {
  return {
    type: actionTypes.UPDATE_FORCE_RANK_GROUP_SUCCESS
  }
}

export const updateForceRankGroupFailed = () => {
  return {
    type: actionTypes.UPDATE_FORCE_RANK_GROUP_FAILED
  }
}

export const deleteForceRankGroup = (recordId, page) => {
  return dispatch => {
    dispatch(deleteForceRankGroupStart())
    forceRankGroupAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'ForceRankGroup Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteForceRankGroupSuccess())
        dispatch(fetchForceRankGroup(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteForceRankGroupFailed())
      })
  }
}

export const deleteForceRankGroupStart = () => {
  return {
    type: actionTypes.DELETE_FORCE_RANK_GROUP_START
  }
}

export const deleteForceRankGroupSuccess = () => {
  return {
    type: actionTypes.DELETE_FORCE_RANK_GROUP_SUCCESS
  }
}

export const deleteForceRankGroupFailed = () => {
  return {
    type: actionTypes.DELETE_FORCE_RANK_GROUP_FAILED
  }
}

export const fetchForceRankGroupFilterForceRankGroup = filter => {
  return dispatch => {
    dispatch(fetchForceRankGroupFilterForceRankGroupStart())
    baseAxios
      .get('/dropdown_force_rank_group/force_rank_group', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchForceRankGroupFilterForceRankGroupSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchForceRankGroupFilterForceRankGroupFailed(error?.response?.data?.message))
      })
  }
}

export const fetchForceRankGroupFilterForceRankGroupStart = () => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_START
  }
}

export const fetchForceRankGroupFilterForceRankGroupSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_SUCCESS,
    data
  }
}

export const fetchForceRankGroupFilterForceRankGroupFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_FAILED,
    errorMessage
  }
}
